<template>
  <div class="wrapper">
    <header>
      <div class="logo"></div>
    </header>
    <div id="mycontent">
      <Home />
      <Family />
      <Team />
      <Recruit />
    </div>
    <Footer />
    <Model />
    <ReModel />
    <div class="modal" v-if="myshow">
      <div class="colse" @click="close">x</div>
    </div>
  </div>
</template>

<script>
import Footer from "./mycomoponet/footer";
import Home from "./home";
import Family from "./family";
import Team from "./team";
import Model from "./model";
import ReModel from "./recruitModal.vue";
import Recruit from "./recruit.vue";
import { mapGetters, mapMutations } from "vuex";
export default {
  data() {
    return {
      show: false,
      page: "index",
      isShow: false,
      myshow: true,
    };
  },
  //   mounted() {},
  //   computed: {
  //     ...mapGetters({
  //       language: "getType",
  //     }),
  //     home() {
  //       return this.language == "中文" ? "主页" : "Home";
  //     },
  //     about() {
  //       return this.language == "中文" ? "关于我们 " : "About Atlas";
  //     },
  //     team() {
  //       return this.language == "中文" ? "投资团队" : "Our Team";
  //     },
  //     family() {
  //       return this.language == "中文" ? "被投企业 " : "Atlas Family";
  //     },
  //     telus() {
  //       return this.language == "中文" ? "联系我们" : "Contacts";
  //     },
  //   },
  methods: {
    // ...mapMutations(["changelanguage"]),
    // changeTab(value) {
    //   if (this.language == value) {
    //     return;
    //   }
    //   this.changelanguage(value);
    // },
    // showPopup() {
    //   this.show = !this.show;
    // },
    // changeModel(value, name, desc1, desc2) {
    //   this.isShow = value;
    //   this.name = name;
    //   this.desc1 = desc1;
    //   this.desc2 = desc2;
    // },
    // gopage(page) {
    //   if (this.$route.path == `/${page}`) {
    //     this.show = false;
    //     return;
    //   }
    //   this.show = false;
    //   this.$router.push(`/${page}`);
    // },
    close() {
      this.myshow = false;
    },
  },
  components: {
    Footer,
    Home,
    Family,
    Team,
    Model,
    ReModel,
    Recruit,
  },
};
</script>

<style lang="less" scoped>
.wrapper {
  width: 100%;
  position: relative;
  .btn {
    width: 1.23rem;
    height: 0.32rem;
    background-size: 100% 100%;
    position: absolute;
    top: 0.35rem;
    right: 1.2rem;
    display: flex;
    p {
      text-align: center;
      color: #fff;
    }
    .zh {
      width: 50%;
      height: 100%;
    }
    .en {
      width: 50%;
      height: 100%;
    }
  }
  .content {
    margin-top: 1.1rem;
    width: 1.82rem;
    .navitem {
      width: 1.82rem;
      height: 0.9rem;
      p {
        font-size: 0.28rem;
        color: #4e4e4e;
        text-align: center;
        line-height: 0.9rem;
      }
    }
  }
  .active {
    background: rgba(109, 221, 176, 1) !important;
    p {
      color: rgba(255, 255, 255, 1) !important;
    }
  }

  header {
    position: sticky;
    top: 0;
    width: 100%;
    z-index: 11111111;
    height: 1.06rem;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0.01rem 0.01rem 0.18rem 0 rgba(70, 214, 177, 0.58);
    display: flex;
    box-sizing: border-box;
    padding: 0 0.34rem;
    justify-content: space-between;
    align-items: center;
    .logo {
      width: 2.47rem;
      height: 0.8rem;
      background: url("../images/logo.png") no-repeat;
      background-size: 100% 100%;
    }
    .icon {
      width: 0.37rem;
      height: 0.29rem;
      background: url("../images/nav.png");
      background-size: 100% 100%;
    }
  }
  .modal {
    width: 9.59rem;
    height: 7.88rem;
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%) scale(0.6);
    background: url("../images/1111_画板 1.png") no-repeat;
    background-size: 100% 100%;
    z-index: 100;
    box-shadow: rgba(0, 0, 0, 0.2) 0 0 10px 6px;

    .colse {
      position: absolute;
      cursor: pointer;
      width: 0.2rem;
      height: 20%;
      right: 0.3rem;
      top: 0.2rem;
      font-size: 0.4rem;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/h5/index.vue